import React from "react";
var Arrows = function (props) {
    return (React.createElement("div", { className: "title ".concat((props === null || props === void 0 ? void 0 : props.className) ? props === null || props === void 0 ? void 0 : props.className : "") },
        props.title,
        React.createElement("div", { className: "arrows " },
            React.createElement("i", { className: "edel-icon-caret-up ".concat((props === null || props === void 0 ? void 0 : props.isClicked) && !(props === null || props === void 0 ? void 0 : props.sortType)
                    ? "txt_blackOne1"
                    : "txt-oslo_grey", " ") }),
            React.createElement("i", { className: "edel-icon-caret-down ".concat((props === null || props === void 0 ? void 0 : props.isClicked) && (props === null || props === void 0 ? void 0 : props.sortType)
                    ? "txt_blackOne1"
                    : "txt-oslo_grey", " ") }))));
};
export default Arrows;
